

/**
 * Global application footer
 */

// import primary libraries
import React from 'react';
import PropTypes from 'prop-types';
import { Link, withRouter } from 'react-router-dom';

function Footer() {
  return(
    <footer className="footer">
      <div className="yt-container " style={{padding: "20px"}}>
        <div className="yt-row space-between with-gutters">
          <div className="yt-col full s_40">
            <h4>Pro-ficiency, LLC</h4>
            {/* <p>Pro-ficiency uses simulation training systems to create a more effective and enjoyable training experience for investigators and site/team staff by modeling the actual challenges that site/team staff face with each clinical trial. We value your time. In an effort to reduce training time, this program is designed to eliminating repeated training on redundant topics and to allow site/team staff to test out of previously ‘passed’ subject matter.  </p> */}
            <p>Use of Pro-ficiency is a way for training programs to have a remote and always accessible equivalent to attending in-person training. By using this system you are compliantly participating in and attesting to training and certification in your assigned training programs.</p>
          </div>
          <div className="yt-col full s_50">
            <div className="yt-row with-gutters">
              <div className="yt-col _50 s_10">

              </div>
              <div className="yt-col _50 s_30">
                <h4>Use Pro-ficiency</h4>
                <ul className="footer-nav">
                  <li><a href="http://pro-ficiency.com">Pro-ficiency Website</a></li>
                  <li><a href="https://pro-ficiency-static.s3.us-east-2.amazonaws.com/website/Pro-ficiency-Privacy-Policy.pdf" target="_blank">Privacy</a></li>
                </ul>
              </div>

              <div className="yt-col full s_50">
                <h4>Connect With Us</h4>
                <ul className="footer-nav">
                  <li>
                    <a href="mailto:prosupport@simulations-plus.com"><i className="-icon fal fa-envelope"/> prosupport@simulations-plus.com</a>
                  </li>
                  <li>
                    <a href="tel:919-973-8154"><i className="-icon fas fa-phone"/>(919) 973-8154</a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="subfooter">
        <p className="u-centerText">&copy; {new Date().getFullYear()} by Pro-ficiency &reg; <a href="/release-notes">Version {appVersion} </a></p>
      </div>
    </footer>
  )
}

export default withRouter(Footer);



// WEBPACK FOOTER //
// global/components/navigation/Footer.js.jsx